/** Contadores locales de sesión (mostrados en la TopBar); no sustituyen a la analítica del portal. */

let state = {
	pageViews: 0,
	buttonClicks: 0,
	quizAnswers: 0,
	finishes: 0,
};

const listeners = new Set();

function emptyState() {
	return { pageViews: 0, buttonClicks: 0, quizAnswers: 0, finishes: 0 };
}

export function resetSessionKpi() {
	state = emptyState();
	listeners.forEach((l) => l());
}

/**
 * @param {"page_view"|"button_click"|"quiz_answer"|"finish"} kind
 */
export function bumpSessionKpi(kind) {
	const next = { ...state };
	if (kind === "page_view") next.pageViews += 1;
	else if (kind === "button_click") next.buttonClicks += 1;
	else if (kind === "quiz_answer") next.quizAnswers += 1;
	else if (kind === "finish") next.finishes += 1;
	state = next;
	listeners.forEach((l) => l());
}

export function getSessionKpiSnapshot() {
	return state;
}

export function subscribeSessionKpi(listener) {
	listeners.add(listener);
	return () => listeners.delete(listener);
}
